<template>
  <div class="container">
    <div id="swagger-ui" :class="$style.document"></div>

    <Faq></Faq>
  </div>
</template>

<script>
import SwaggerUI from 'swagger-ui'
import 'swagger-ui/dist/swagger-ui.css'
import swaggerJson from '../swagger/swagger.json'
import Faq from '../components/Faq'

export default {
  components: {
    Faq
  },
  mounted () {
    SwaggerUI({
      dom_id: '#swagger-ui',
      spec: swaggerJson,
      link: './assets/swagger.json'
    })
  }
}
</script>

<style lang="scss" module>
.document {
  color: #ccc;
  tr + tr {
    border-top: 1px solid #ccc;
  }
}
</style>
